import { SelectOption } from "./SelectOption"

export interface GetBaseRes {
  id: string,
  idBase: number,
  name: string
}

export default function BaseToSelectOption(base: GetBaseRes): SelectOption {
  return {key: base.id, value: base.name}
}